export default __webpack_public_path__ + "static/media/top-ten-block-7.25ad3fed.svg";